import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_MEMBERS = "getPaginatedMembers";
export const ALL_MEMBERS = "getAllMembers";
export const CREATE_MEMBER_FORM = "createMemberForm";
export const DELETE_MEMBER = "deleteMember";
export const GET_MEMBER_DATA = "getMemberData";
export const CREATE_MEMBER = "createMember";
export const UPDATE_MEMBER = "updateMember";
export const GET_MEMBERS_REPORT = "getMembersReport";
export const GET_MEMBERS_WITH_CREDIT_BALANCE = "getMembersWithCreditBalanceReport";
export const GET_MEMBERS_MERGED_REPORT = "getMembersMergedReport";


// mutation types
export const SET_PAGINATED_MEMBERS = "setPaginatedMembers";
export const SET_ALL_MEMBERS = "setAllMembers";
export const SET_MEMBER_DATA = "setMemberData";
export const SET_MEMBER_META = "setMemberMeta";
export const SET_MEMBER_ERROR = "setMemberError";
export const SET_MEMBER_LOADING = "setMemberLoading";
export const CLEAR_MEMBER_ERROR = "clearMemberError";
export const SET_IS_DISABLED_MEMBER = "setIsDisabledMember";


const state = {
    members: [],
    paginatedMembers: [],
    member_data: {},
    meta_member : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllMembers(state) {
        return state.paginatedMembers;
    },

    allMembers(state) {
        return state.members;
    },

    getMemberData(state) {
        return state.member_data;
    },

    meta_member(state) {
        return state.meta_member;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_MEMBERS](context, payload) {
        context.commit(SET_IS_DISABLED_MEMBER, false);
        context.commit(SET_MEMBER_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/members?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_MEMBER_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_MEMBERS, data);
                context.commit(SET_MEMBER_META, data);
                context.commit(SET_MEMBER_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_MEMBER_LOADING, false);
            context.commit(SET_MEMBER_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_MEMBERS]() {
        return new Promise(resolve => {
            ApiService.get('/membersAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_MEMBER_FORM](context) {
        context.commit(SET_MEMBER_LOADING, false);
        context.commit(SET_MEMBER_ERROR, false);
        context.commit(SET_IS_DISABLED_MEMBER, false);
    },

    [GET_MEMBER_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(CLEAR_MEMBER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/member/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_MEMBER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_MEMBER_DATA, response.data);
                    context.commit(SET_MEMBER_LOADING, false);
                    context.commit(SET_IS_DISABLED_MEMBER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_MEMBER_LOADING, false);
                context.commit(SET_MEMBER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_MEMBER, true);
            });
        });
    },

    [CREATE_MEMBER](context, payload) {
        context.commit(SET_MEMBER_LOADING, false);
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(CLEAR_MEMBER_ERROR);
        return ApiService.post("/member/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_MEMBER_ERROR);
            }
            else{
                context.commit(SET_MEMBER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Eski üye kaydı başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_MEMBER_ERROR);
                context.commit(SET_IS_DISABLED_MEMBER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_MEMBER_LOADING, false);
            context.commit(SET_MEMBER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_MEMBER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_MEMBER](context, payload) {
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(CLEAR_MEMBER_ERROR);
        
        return ApiService.put(`/member/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_MEMBER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı eski üye kaydı başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_MEMBER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_MEMBER_LOADING, false);
            context.commit(SET_MEMBER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_MEMBER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_MEMBER](context, payload) {
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(CLEAR_MEMBER_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/member/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_MEMBER_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı eski üye kaydı başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_MEMBER_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    [GET_MEMBERS_REPORT](context, payload) {
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(CLEAR_MEMBER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_members_report?memberid=${payload.member_id}&x=1`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_MEMBER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_MEMBER_DATA, response.data);
                    context.commit(SET_MEMBER_LOADING, false);
                    context.commit(SET_IS_DISABLED_MEMBER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_MEMBER_LOADING, false);
                context.commit(SET_MEMBER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_MEMBER, true);
            });
        });
    },

    [GET_MEMBERS_MERGED_REPORT](context) {
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(CLEAR_MEMBER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_members_merged_report`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_MEMBER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_MEMBER_DATA, response.data);
                    context.commit(SET_MEMBER_LOADING, false);
                    context.commit(SET_IS_DISABLED_MEMBER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_MEMBER_LOADING, false);
                context.commit(SET_MEMBER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_MEMBER, true);
            });
        });
    },

    [GET_MEMBERS_WITH_CREDIT_BALANCE](context) {
        context.commit(SET_IS_DISABLED_MEMBER, true);
        context.commit(SET_MEMBER_LOADING, true);
        context.commit(CLEAR_MEMBER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_members_with_credit_balance`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_MEMBER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_MEMBER_DATA, response.data);
                    context.commit(SET_MEMBER_LOADING, false);
                    context.commit(SET_IS_DISABLED_MEMBER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_MEMBER_LOADING, false);
                context.commit(SET_MEMBER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_MEMBER, true);
            });
        });
    },
    
    
};

const mutations = {

    [SET_PAGINATED_MEMBERS](state, paginatedMembers) {
        state.paginatedMembers = paginatedMembers.data;
    },

    [SET_ALL_MEMBERS](state, members) {
        state.members = members;
    },

    [SET_MEMBER_DATA](state, members_data) {
        state.members_data = members_data;
        state.errors = [];
    },

    [SET_MEMBER_META](state, meta_member) {
        state.meta_member = meta_member;
    },

    [SET_MEMBER_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_MEMBER_ERROR](state) {
        state.errors = [];
    },
    
    [SET_MEMBER_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_MEMBER](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
